export default __webpack_public_path__ + "assets/check-circle-component.9fc1dbab.svg";